export const API = {
	auth: {
		login: `/user/login`,
		check2FA: `/user/check2FA`,
		requestReset: `/user/request-reset-password`,
		resetPassword: `/user/reset-password`,
	},
	users: {
		profile: `/user/profile`,
		create: `/user/register/`,
		edit: `/user/`,
		delete: `/user/`,
		list: `/user`,
	},
	alerts: {
		create: `/alert`,
		edit: `/alert/`,
		delete: `/alert/`,
		list: `/alert`,
	},
	appointments: {
		create: `/appointment`,
		edit: `/appointment/`,
		delete: `/appointment/`,
		list: `/appointment`,
		schedule: `/appointment/schedule`,
		bulk: `/appointment/bulk`,
		user: `/appointment/user`,
	},
	permissions: {
		create: `/permission`,
		edit: `/permission/`,
		delete: `/permission/`,
		list: `/permission`,
		base: `/permission`,
	},
	holidays: {
		create: `/holiday`,
		edit: `/holiday/`,
		delete: `/holiday/`,
		list: `/holiday`,
		sync: `/holiday/sync`,
	},
	timechangerequests: {
		create: `/timechangerequest`,
		edit: `/timechangerequest/`,
		delete: `/timechangerequest/`,
		list: `/timechangerequest`,
		base: `/timechangerequest`,
	},
};
